import _ from 'lodash';

export const getInitialPresentationUrl = state => {
  return decodeURI(
    _.get(state, 'pages.editProfile.connectTalkDetails.presentation')
  );
};
